export const imgDefaultValues: FormData = {
  engineId: 'sd3',
  name: '',
  cfg_scale: 9,
  height: 1024,
  width: 1024,
  steps: 50,
  clip_guidance_preset: 'NONE',
  type: 'Text to Image',
  src: '',
  promptWeight: 1.0,
  image_strength: 0.0,
  aiModels: 'stabilityAi',
  openSourceModel: 'kandinsky2',
  negativePrompt: '',
  magicPrompt: 'AUTO',
  style_present: 'None',
  style: '',
  style_type: 'GENERAL',
  resolution: '1024x1024',
  view: '',
  subject: '',
  environment: '',
  tone: '',
  sampler: 'AUTO',
  toneDefaultValues: [],
  viewDefaultValues: [],
  openAiModels: 'createImage',
  ideogramModel: 'ideogram-v3-turbo',
  falModel: 'pro',
  imageSize: 'landscape_4_3',
  inference_steps: 28,
  fal_seed: 0,
  guidance_scalefloat: 3.5,
  sync_mode: false,
  num_images: 1,
  safety_tolerance: 2,
  image_weight: 50,
  model: 'dall-e-3',
  prompt: '',
  numbersOfVariations: '',
  size: '1024x1024',
  quality: 'standard',
  sizeGenerate: '1024x1024',
  mode: 'default',
  aspect_ratio: '',
  aspect_ratio_ideogram: '1x1',
  output_format: 'png',
  influenceStrength: 0,
};

export const versions = [
  {
    version: 'stable-diffusion-512-v2-1',
    dimensions: ['512x896', '896x512'],
  },
  {
    version: 'stable-diffusion-xl-1024-v1-0',
    dimensions: [
      '1024x1024',
      '1152x896',
      '1216x832',
      '1344x768',
      '1536x640',
      '640x1536',
      '768x1344',
      '832x1216',
      '896x1152',
    ],
  },
  {
    version: 'stable-diffusion-xl-1024-v1-0',
    dimensions: [
      '1024x1024',
      '1152x896',
      '1216x832',
      '1344x768',
      '1536x640',
      '640x1536',
      '768x1344',
      '832x1216',
      '896x1152',
    ],
  },
  { version: 'stable-diffusion-v1-6', dimensions: ['320x320', '1536x1536'] },
];

export const openAiModelsImage = [
  {
    value: 'dall-e-2',
    name: 'DALL-E-2',
  },
  {
    value: 'dall-e-3',
    name: 'DALL-E-3',
  },
];

export enum IdeogramMagicPrompt {
  AUTO = 'AUTO',
  ON = 'ON',
  OFF = 'OFF',
}

export enum IdeogramStyleType {
  AUTO = 'AUTO',
  GENERAL = 'GENERAL',
  REALISTIC = 'REALISTIC',
  DESIGN = 'DESIGN',
}

export enum IdeogramResolution {
  RESOLUTION_512_1536 = '512x1536',
  RESOLUTION_576_1408 = '576x1408',
  RESOLUTION_576_1472 = '576x1472',
  RESOLUTION_576_1536 = '576x1536',
  RESOLUTION_640_1344 = '640x1344',
  RESOLUTION_640_1408 = '640x1408',
  RESOLUTION_640_1472 = '640x1472',
  RESOLUTION_640_1536 = '640x1536',
  RESOLUTION_704_1152 = '704x1152',
  RESOLUTION_704_1216 = '704x1216',
  RESOLUTION_704_1280 = '704x1280',
  RESOLUTION_704_1344 = '704x1344',
  RESOLUTION_704_1408 = '704x1408',
  RESOLUTION_704_1472 = '704x1472',
  RESOLUTION_736_1312 = '736x1312',
  RESOLUTION_768_1088 = '768x1088',
  RESOLUTION_768_1216 = '768x1216',
  RESOLUTION_768_1280 = '768x1280',
  RESOLUTION_768_1344 = '768x1344',
  RESOLUTION_800_1280 = '800x1280',
  RESOLUTION_832_960 = '832x960',
  RESOLUTION_832_1024 = '832x1024',
  RESOLUTION_832_1088 = '832x1088',
  RESOLUTION_832_1152 = '832x1152',
  RESOLUTION_832_1216 = '832x1216',
  RESOLUTION_832_1248 = '832x1248',
  RESOLUTION_864_1152 = '864x1152',
  RESOLUTION_896_960 = '896x960',
  RESOLUTION_896_1024 = '896x1024',
  RESOLUTION_896_1088 = '896x1088',
  RESOLUTION_896_1120 = '896x1120',
  RESOLUTION_896_1152 = '896x1152',
  RESOLUTION_960_832 = '960x832',
  RESOLUTION_960_896 = '960x896',
  RESOLUTION_960_1024 = '960x1024',
  RESOLUTION_960_1088 = '960x1088',
  RESOLUTION_1024_832 = '1024x832',
  RESOLUTION_1024_896 = '1024x896',
  RESOLUTION_1024_960 = '1024x960',
  RESOLUTION_1024_1024 = '1024x1024',
  RESOLUTION_1088_768 = '1088x768',
  RESOLUTION_1088_832 = '1088x832',
  RESOLUTION_1088_896 = '1088x896',
  RESOLUTION_1088_960 = '1088x960',
  RESOLUTION_1120_896 = '1120x896',
  RESOLUTION_1152_704 = '1152x704',
  RESOLUTION_1152_832 = '1152x832',
  RESOLUTION_1152_864 = '1152x864',
  RESOLUTION_1152_896 = '1152x896',
  RESOLUTION_1216_704 = '1216x704',
  RESOLUTION_1216_768 = '1216x768',
  RESOLUTION_1216_832 = '1216x832',
  RESOLUTION_1248_832 = '1248x832',
  RESOLUTION_1280_704 = '1280x704',
  RESOLUTION_1280_768 = '1280x768',
  RESOLUTION_1280_800 = '1280x800',
  RESOLUTION_1312_736 = '1312x736',
  RESOLUTION_1344_640 = '1344x640',
  RESOLUTION_1344_704 = '1344x704',
  RESOLUTION_1344_768 = '1344x768',
  RESOLUTION_1408_576 = '1408x576',
  RESOLUTION_1408_640 = '1408x640',
  RESOLUTION_1408_704 = '1408x704',
  RESOLUTION_1472_576 = '1472x576',
  RESOLUTION_1472_640 = '1472x640',
  RESOLUTION_1472_704 = '1472x704',
  RESOLUTION_1536_512 = '1536x512',
  RESOLUTION_1536_576 = '1536x576',
  RESOLUTION_1536_640 = '1536x640',
}

export enum IdeogramAspect {
  ASPECT_1_1 = '1x1',
  ASPECT_1_3 = '1x3',
  ASPECT_3_1 = '3x1',
  ASPECT_1_2 = '1x2',
  ASPECT_2_1 = '2x1',
  ASPECT_2_3 = '2x3',
  ASPECT_3_2 = '3x2',
  ASPECT_3_4 = '3x4',
  ASPECT_4_3 = '4x3',
  ASPECT_4_5 = '4x5',
  ASPECT_5_4 = '5x4',
  ASPECT_9_16 = '9x16',
  ASPECT_16_9 = '16x9',
  ASPECT_10_16 = '10x16',
  ASPECT_16_10 = '16x10',
}

export const magicPromptTypes = ['AUTO', 'ON', 'OFF'];

export interface FormData {
  whoIsChanging?: any;
  engineId: string;
  name: string;
  aiModels: string;
  cfg_scale: number;
  height: number;
  width: number;
  steps: number;
  clip_guidance_preset: string;
  type: string;
  src: string;
  promptWeight: number;
  image_strength: number;
  negativePrompt: string;
  style_present: string;
  style: string;
  style_type: string;
  resolution: string;
  image_weight: number;
  openSourceModel: string;
  view: string;
  subject: string;
  environment: string;
  tone: string;
  sampler: string;
  toneDefaultValues: [];
  viewDefaultValues: [];
  openAiModels: string;
  prompt: string;
  numbersOfVariations: string;
  size: string;
  quality: string;
  sizeGenerate: string;
  inputPreview?: string;
  uploadImage?: File | null;
  model: string;
  ideogramModel: string;
  aspect_ratio_ideogram: string;
  magicPrompt: string;
  falModel: string;
  imageSize: string;
  inference_steps: number;
  fal_seed: number;
  guidance_scalefloat: number;
  sync_mode: boolean | string;
  num_images: number;
  safety_tolerance: number;
  aiEditSelectedType?: string;

  expandedImagePreview?: string;
  dimensions?: { top: number; left: number; right: number; bottom: number };

  aiEraseSelectedType?: string;
  selectedEnhancedResolution?: string;

  maskInputPreview?: string;
  maskInputPreviewToShow?: string;
  Data?: any;
  searchPrompt?: string;

  imageToImageSelectedType?: string;
  influenceStrength?: number;

  aspect_ratio?: string;
  mode?: string;
  output_format?: string;
  selectedImageToImageAspectRatio?: string;
}

export const imageTypes = [
  'prompt',
  'subject',
  'environment',
  'tone',
  'view',
  'style',
  'negativePrompt',
];
export const aiImageGeneratorInputs = [
  {
    name: 'videoPrompt',
    labelName: 'Prompt',
    placeholder:
      'Connect or type a description of the video you want to generate.',
    handleId: 'videoPrompt',
    isCollapsed: true,
  },
  {
    name: 'prompt',
    labelName: 'Prompt',
    placeholder:
      'Connect or type a description of the image you want to generate.',
    handleId: 'prompt',
    isCollapsed: true,
  },
  {
    name: 'subject',
    labelName: 'Subject',
    placeholder: 'Connect or type the subject of your image.',
    handleId: 'subject',
    isCollapsed: false,
  },
  {
    name: 'environment',
    labelName: 'Environment',
    placeholder: 'Connect or type the environment your subject will be in.', // Add placeholder if needed
    handleId: 'environment',
    isCollapsed: false,
  },
  {
    name: 'tone',
    labelName: 'Tone',
    placeholder: 'Connect or type the color and lighting of your image.', // Add placeholder if needed
    handleId: 'tone',
    isCollapsed: false,
  },
  {
    name: 'view',
    labelName: 'View',
    placeholder: 'Connect or type the angle of view of your image.', // Add placeholder if needed
    handleId: 'view',
    isCollapsed: false,
  },
  {
    name: 'style',
    labelName: 'Style',
    placeholder: 'Connect or type the style you want your image to follow.', // Add placeholder if needed
    handleId: 'style',
    isCollapsed: false,
  },
  {
    name: 'negativePrompt',
    labelName: 'Negative Prompt',
    placeholder: 'Connect or type ',
    handleId: 'negativePrompt',
    isCollapsed: false,
  },
];
